const cards = [
    {
        options: {
            itemGap: 16,
            itemWidth: 248,
            moreIcon: 'chevron-2',
            type: 'card-video',
        },
        size: {
            height: 0,
            width: 1,
        },
        type: 'slider-mobile',
    },
];
export default cards;
